import React, { Component } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { BsFillChatTextFill } from "react-icons/bs";
import { TbMessageCircle } from "react-icons/tb";
import { VscChromeClose } from "react-icons/vsc";
import { connect } from "react-redux";
import live from "../../../../assets/Images/live-class.png";

export class MyAppointment extends Component {
    render() {
        const { appointments } = this.props;
        return (
            <React.Fragment>
                {appointments &&
                    <React.Fragment>
                        <div className=" py-3 px-4">
                            <div style={{ fontSize: "18px", fontWeight: "500" }}>
                                My Appointments
                            </div>
                        </div>

                        <div
                            className="appointment hidden-scroll-bar gap-3 px-4"
                            style={{
                                gridTemplateColumns: "repeat(2,1fr)",
                                overflowX: "scroll",
                            }}
                        >
                            {appointments.map((value, index) =>
                                <div className="appointment1-card py-2 px-2   ">
                                    <div className="d-flex flex-row justify-content-around align-items-center ">
                                        <div className="flex-shrink-1 px-3">
                                            <BsFillChatTextFill className="msgbtn" />
                                        </div>
                                        <div className="flex-grow-1 ps-2">
                                            <div className="d-flex flex-column h-100 justify-content-between align-content-between">
                                                <span className="fw-nomal  fw-500" style={{ fontSize: '14px' }}>
                                                    Parent meeting
                                                </span>
                                                <span className="  mt-2 " style={{ fontSize: '12px' }}>
                                                    {/* Deepak(Student) parent meeting, Today
                                                    12.00 PM */}
                                                    {value?.description}
                                                    {value?.link}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="flex-shrink-1 pe-2 align-self-start">
                                            <VscChromeClose className="fs-3" />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </React.Fragment>
                }
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(MyAppointment);
